import { getFormattedDate } from 'helpers/dates';
import { CompanyAICIStatsCategory } from 'types/recommendations';
import { isObject } from 'utils/helpers/object';

import { AI_CI_CATEGORIES, AICI_LAST_GENERATED_DATE_FORMAT, DEFAULT_LAGGING_COUNT } from './constants';

export const categoryLabel = (key: string | null): string | null =>
  key ? (AI_CI_CATEGORIES.find((category) => category.key === key)?.label ?? key) : null;

export const categoryLabels = (categories: string[]): string =>
  categories.map((key) => categoryLabel(key) ?? key).join(', ');

export const getCompanyAICICategoryLaggingCount = (
  categories: CompanyAICIStatsCategory[] | undefined,
  categoryKey: string
) => categories?.find((category) => category.category === categoryKey)?.lagging_count ?? DEFAULT_LAGGING_COUNT;

export const humanizeEvidenceValue = (value: string): string =>
  value
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const getEvidencePageTitle = (extractedData: Record<string, unknown>): string =>
  typeof extractedData.title === 'string' && extractedData.title ? extractedData.title : 'Untitled page';

export const toInlineString = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  if (Array.isArray(value)) {
    if (value.every((item) => ['string', 'number', 'boolean'].includes(typeof item) || item === null)) {
      return value.map((item) => String(item ?? '')).join(', ');
    }

    return JSON.stringify(value);
  }

  if (isObject(value)) {
    return JSON.stringify(value);
  }

  return String(value);
};

export const formatLastGenerated = (value?: string | null) =>
  value ? `Last generated ${getFormattedDate(value, AICI_LAST_GENERATED_DATE_FORMAT)}` : 'Not generated yet';
